/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotopick3Inputs */

const en_aiflowphotopick3 = /** @type {(inputs: Aiflowphotopick3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a photo`)
};

const de_aiflowphotopick3 = /** @type {(inputs: Aiflowphotopick3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto auswählen`)
};

/**
* | output |
* | --- |
* | "Choose a photo" |
*
* @param {Aiflowphotopick3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotopick3 = /** @type {((inputs?: Aiflowphotopick3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotopick3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotopick3(inputs)
	return de_aiflowphotopick3(inputs)
});
export { aiflowphotopick3 as "aiFlowPhotoPick" }